import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { TrackerProvider } from "./context/TrackerContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <AuthProvider>
      <TrackerProvider>
        <App />
      </TrackerProvider>
    </AuthProvider>
  </HelmetProvider>
);
